const LogType = {
    REDUX: 'REDUX',
    ERROR: 'ERROR',
    CUSTOM: 'CUSTOM'
};
const _buffer = [];
export { LogType };
export default {
    add (name, time, type, log) {
        const logEntry = {
            name,
            time,
            type,
            log
        };
        _buffer.push(logEntry);
    },
    getLogs () {
        return _buffer;
    },
    filterLogs (timeFrom, timeTo, logTypes) {
        return _buffer.filter((entry)=>(timeFrom ? entry.time.valueOf() > timeFrom.valueOf() : true) && (timeTo ? entry.time.valueOf() <= timeTo.valueOf() : true) && (logTypes && logTypes.length > 0 ? logTypes.includes(entry.type) : true));
    },
    filterLogsByType (logTypes) {
        return _buffer.filter((entry)=>logTypes && logTypes.length > 0 ? logTypes.includes(entry.type) : true);
    },
    clear () {
        _buffer.length = 0;
    }
};
